import { render } from "./InfoToast.vue?vue&type=template&id=23618cbc&scoped=true"
import script from "./InfoToast.vue?vue&type=script&lang=js"
export * from "./InfoToast.vue?vue&type=script&lang=js"

import "./InfoToast.vue?vue&type=style&index=0&id=23618cbc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3809301774/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23618cbc"]])

export default __exports__